import sComponents from "../../../../../web-sh/src/pages/admin/settings/components/security";
import ChangeAccountPassword from "./AccountPassword";
import ChangeMasterPassword from "./MasterPassword";
import TwoFA from "./TwoFA";
import EmergencyAccess from "./EmergencyAccess";

sComponents.EmergencyAccess = EmergencyAccess;

const securityComponents = {
  ...sComponents,
  ChangeAccountPassword,
  ChangeMasterPassword,
  TwoFA
}

export default securityComponents